function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.8731 7.75405L14.792 2.7973C15.019 2.57027 15.019 2.22973 14.792 2.0027L14.0353 1.20811C13.8082 0.981081 13.4677 0.981081 13.2407 1.20811L8.28391 6.16486C8.13255 6.31622 7.90553 6.31622 7.75418 6.16486L2.79742 1.17027C2.57039 0.943243 2.22985 0.943243 2.00282 1.17027L1.20823 1.96486C0.981203 2.19189 0.981203 2.53243 1.20823 2.75946L6.16499 7.71622C6.31634 7.86757 6.31634 8.09459 6.16499 8.24594L1.17039 13.2405C0.943365 13.4676 0.943365 13.8081 1.17039 14.0351L1.96499 14.8297C2.19201 15.0568 2.53255 15.0568 2.75958 14.8297L7.71634 9.87297C7.86769 9.72162 8.09472 9.72162 8.24607 9.87297L13.2028 14.8297C13.4299 15.0568 13.7704 15.0568 13.9974 14.8297L14.792 14.0351C15.019 13.8081 15.019 13.4676 14.792 13.2405L9.8731 8.28378C9.72174 8.13243 9.72174 7.9054 9.8731 7.75405Z",
  fill: "#C4C4C4"
}));

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.09c9becbbc3d465d7dc2c20df0b00423.svg";
export { ForwardRef as ReactComponent };